module.exports = __webpack_public_path__ + "static/media/redCrossIcon.e961609f.svg";